export function AdminMini (pConfig)
{
  return (
  {
    name : 'EditorToolbarMiniConfig',

    GroupsChange:
    {
      BlockActions:
      {
        visible: false
      },

      BlockStyles:
      {
        visible: false
      },

      BlockStylesEmail:
      {
        visible: false
      },

      FontColorsEmail:
      {
        visible: false
      },

      HistoryActions:
      {
        visible : false
      },

      TextAlign:
      {
        visible : false
      },

      FontColors:
      {
        visible : false
      },

      TextActions:
      {
        visible : false
      },

      CopyPaste:
      {
        visible : false
      },

      HTML:
      {
        visible: false
      },

      BigSizeButtons:
      {
        visible: false
      },

      BigSizeButtonsEvent:
      {
        visible: false
      },

      BigSizeButtonsEmail:
      {
        visible: false
      }
    }
  });
}